import { CloseOutlined, FilterOutlined } from '@ant-design/icons'
import { BBDTag, Horizontal } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'

export type FiltersAppliedButtonProps = {
  tooltipContent?: React.ReactNode
  onClearFilters: () => void
}

export function FiltersAppliedButton({
  tooltipContent,
  onClearFilters,
}: FiltersAppliedButtonProps) {
  return (
    <Tooltip
      title={
        tooltipContent ||
        'Filters are currently applied. Click the "x" to clear all filters.'
      }
    >
      <BBDTag
        style={{
          minHeight: 32,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
        }}
        theme2
      >
        <Horizontal gap={6} alignItems='center'>
          <FilterOutlined />
          <span>Filters Applied</span>
          <CloseOutlined
            onClick={onClearFilters}
            style={{ marginLeft: 4, fontSize: 10 }}
          />
        </Horizontal>
      </BBDTag>
    </Tooltip>
  )
}
